'use client';

import { Markdown, cn } from '@scatterlab/zeta-core';
import {
  ALLOWED_ELEMENTS,
  BASE_ALLOWED_ELEMENTS,
} from '@scatterlab/zeta-core/src/components/Markdown';
import { FC, memo, useMemo } from 'react';
import remarkGfm from 'remark-gfm';

import { BubbleTheme } from './bubble-theme';
import { ThemedMarkdownComponents } from './ThemedMarkdownComponents';

export type BubbleMarkdownProps = {
  message: string;
  className?: string;
  isLinkAllowed?: boolean;
  theme?: BubbleTheme;
  isMine?: boolean;
};

const BubbleMarkdown: FC<BubbleMarkdownProps> = ({
  message,
  className,
  isLinkAllowed,
  theme = BubbleTheme.DEFAULT,
  isMine = false,
}) => {
  const MarkdownComponents = useMemo(
    () => ThemedMarkdownComponents(theme, isMine),
    [theme, isMine],
  );
  return (
    <Markdown
      className={cn(
        'body16 whitespace-pre-wrap break-all text-gray-200',
        className,
      )}
      components={MarkdownComponents}
      allowedElements={isLinkAllowed ? ALLOWED_ELEMENTS : BASE_ALLOWED_ELEMENTS}
      remarkPlugins={isLinkAllowed ? [remarkGfm] : undefined}
    >
      {message}
    </Markdown>
  );
};
export default memo(BubbleMarkdown);
